import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import React from "react";
import { number, string, object } from "prop-types";
import { Doughnut } from "react-chartjs-2";
import Styled from "styled-components";
var ChartWrap = Styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: relative;\n\tdisplay: flex;\n \twidth: ", "px;\n\theight: ", "px;\n \talign-self: center;\n\tmargin-bottom: 12px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var Emoji = Styled.img(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\theight: ", "px;\n\twidth: ", "px;\n\tmargin-top: ", "px;\n\tmargin-left: ", "px;\n\tposition: absolute;\n"])), function (props) {
  return props.emojiHeight;
}, function (props) {
  return props.emojiWidth;
}, function (props) {
  return props.emojix;
}, function (props) {
  return props.emojiy;
});
var DonutWrap = Styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tright: 0px;\n\tposition: relative;\n"])));
export var EmojiDonut = function EmojiDonut(_ref) {
  var image = _ref.image,
      data = _ref.data,
      options = _ref.options,
      emojix = _ref.emojix,
      emojiy = _ref.emojiy,
      emojiHeight = _ref.emojiHeight,
      emojiWidth = _ref.emojiWidth,
      cutoutPercentage = _ref.cutoutPercentage,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/React.createElement(ChartWrap, {
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement(Emoji, {
    src: image,
    emojix: emojix,
    emojiy: emojiy,
    width: emojiWidth,
    height: emojiHeight,
    emojiHeight: emojiHeight,
    emojiWidth: emojiWidth
  }), /*#__PURE__*/React.createElement(DonutWrap, null, /*#__PURE__*/React.createElement(Doughnut, {
    cutoutPercentage: cutoutPercentage,
    data: data,
    options: options
  })));
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

EmojiDonut.propTypes = {
  cutoutPercentage: number,
  width: number,
  height: number,
  emojiHeight: number,
  emojiWidth: number,
  image: string.isRequired,
  data: object.isRequired,
  options: object.isRequired
};
EmojiDonut.defaultProps = {
  cutoutPercentage: 0,
  width: 100,
  height: 100,
  emojiHeight: 100,
  emojiWidth: 100
};